<template>
  <div>
    <header class="top-0 text-second w-full fixed h-14 px-3 flex justify-between rounded-b-lg shadow bg-white place-items-center">
      <button class="h-8" @click="$router.push('/')">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
          <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
        </svg>
      </button>

      <span class="text-xl font-extrabold">Корзина</span>

      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8">
        <path stroke-linecap="round" stroke-linejoin="round" d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
      </svg>
    </header>
    
    <div class="flex flex-col pt-16 p-3 h-screen">
      <div>
        <button class="bg-white shadow text-xs font-bold flex float-right place-items-center p-2 rounded-xl" @click="clearBasket()">
          <span class="ml-2 mr-1">Удалить заказ</span>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
            <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
          </svg>
        </button>
      </div>

      <ul class="flex justify-evenly flex-wrap">
        <template v-for="slot in $store.getters.currentSlots">
          <li class="form_radio_btn" :key="slot.id">
            <input type="radio" :id="`slot-${slot.id}`" name="slot" class="appearance-none" :disabled="!slot.available" @change="$store.commit('setSelectedSlot', slot.id)">
            <label :for="`slot-${slot.id}`" class="inline-block cursor-pointer mt-2 text-white text-center bg-primary py-1 px-1 w-20 rounded-lg leading-4 text-base font-bold h-10 transition-all">
              {{ `${slot.start_time.slice(0, -3)}-${slot.end_time.slice(0, -3)}` }}
            </label>
          </li>
        </template>
      </ul>
      
      <button v-if="$store.getters.hasNotPayedOrder" class="bg-accent mt-2 shadow text-xs text-white float-right font-bold h-8 rounded-xl" @click="cancleMyOrders()">
        <svg v-if="loadingCancleMyOrders" aria-hidden="true" role="status" class="inline mr-2 w-4 h-4 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB"></path>
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor"></path>
        </svg>
        <span>Отменить мои заказы</span>
      </button>

      <div v-if="successCancledOrders" class="bg-accent mt-2 shadow text-xs text-white flex items-center justify-center place-items-end font-bold h-8 rounded-xl">
        <span>Вы успешно отменили свои заказы</span>
      </div>

      <div class="bg-white space-y-4 w-full overflow-x-auto flex-grow mt-2 rounded-xl p-2">
        <div v-if="loading" class="min-h-full grid grid-cols-1 gap-1 place-items-center">
          <Loading/>
        </div>
        <template v-else-if="basketItems.length > 0">
          <BasketItem v-for="item in basketItems" :item="item" :key="item.item.id"/>
          <div v-if="toGoPackage" class="flex place-items-center w-full">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="text-second w-8 h-8 ml-1">
              <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 10.5V6a3.75 3.75 0 1 0-7.5 0v4.5m11.356-1.993 1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 0 1-1.12-1.243l1.264-12A1.125 1.125 0 0 1 5.513 7.5h12.974c.576 0 1.059.435 1.119 1.007ZM8.625 10.5a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm7.5 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
            </svg>
            <div class="grid grid-rows-2 ml-2 w-52">
              <span class="text-xs ml-2 font-bold">{{ toGoPackage.name }}</span>
              <span class="text-xs ml-2" style="-webkit-line-clamp: 1; display: -webkit-box; -webkit-box-orient: vertical; overflow: hidden;">{{ toGoPackage.sum }} ₽</span>
            </div>
          </div>
          <DiscountItem v-for="(discount, index) in discounts" :item="discount" :key="`discount-${index}`"/>
        </template>
        <div v-else class="text-2xl font-extrabold text-inactive min-h-full grid grid-cols-1 gap-1 place-items-center text-center">
          Корзина пуста :(
        </div>
      </div>

      <label v-if="availableToGo" class="flex items-center p-2 pl-3 bg-white rounded-xl mt-2">
        <input id="to-go-checkbox" type="checkbox" v-model="isToGo" class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded" @change="changeToGoOrder">
        <span for="to-go-checkbox" class="ms-2 ml-2 text-base font-medium">С собой</span>
      </label>

    </div>
  </div>
</template>

<script>
import BasketItem from './BasketItem'
import DiscountItem from './DiscountItem'
import Loading from '@/components/ui/Loading'

export default {
  props: ['payFunc', 'toBasketFunc'],

  data: () => ({
    loading: true,
    loadingUpload: false,
    loadingCancleMyOrders: false,
    successCancledOrders: false,

    discounts: [],
    toGoPackage: {aboba: 1},

    availableToGo: false,
    isToGo: false,
    
    selectedSlot: undefined,
  }),

  async mounted() {
    this.loading = true
    try {
      this.toGoPackage = null
      this.$store.commit('setSelectedDeliveryArea', null)
      this.$store.commit('mb_setClick', null)
      // window.Telegram.WebApp.MainButton.offClick(this.toBasketFunc)
      const order = await this.$store.dispatch('calculateOrder', { dishes: this.$store.getters.basketForUpload })
      this.discounts = order.discounts
      this.toGoPackage = order.package_to_go
      this.changeTgButton(order.unpaid_sum)
      this.availableToGo = await this.$store.dispatch('getAvailableToGoOrders')
      await this.$store.dispatch('loadCurrentSlots')
      this.$store.commit('setSelectedSlot', undefined)
    } finally {
      this.loading = false
    }
  },

  computed: {
    basketItems() {
			return this.$store.getters.basket != undefined 
			       ? Object.values(this.$store.getters.basket) 
						 : []
		},
    summ() {
			return this.basketItems.reduce(
				(accumulator, val) => accumulator + (val.quantity * val.item.price), 0
			)
		},
    currentSlotsSelected() {
      let result = []
      this.$store.getters.currentSlots.forEach(elem => {
        result.push({ 
          text: `${elem.start_time.slice(0, -3)}-${elem.end_time.slice(0, -3)}`,
          value: elem.id
        })
      })
      return result
    }
  },

  methods: {
    async uploadBasket() {
      const slots = document.querySelectorAll('input[name="slot"]')
      for (const radio of slots) {
        if (radio.checked) {
          await this.runUploadBasket(radio.value)
          return
        }
      }
		},
    async runUploadBasket(slotId) {
      this.loadingUpload = true
			try {
				await this.$store.dispatch('uploadBasket', slotId)
			} finally {
				this.loadingUpload = false
			}
    },
    async changeSelectedSlot() {
			await this.$store.commit('setSelectedSlot', this.selectedSlot)
		},
    async cancleMyOrders() {
      this.loadingCancleMyOrders = true
      try {
        await this.$store.dispatch('cancleAllOrders')
        this.successCancledOrders = true
      } finally {
        this.loadingCancleMyOrders = false
      }
    },
    async changeToGoOrder() {
      this.loading = true
      // window.Telegram.WebApp.MainButton.hide()
      this.$store.commit('mb_hide')
      this.$store.commit('changeToGoOrder', this.isToGo)
      try {
        this.toGoPackage = null
        const order = await this.$store.dispatch('calculateOrder', { dishes: this.$store.getters.basketForUpload, is_to_go: this.isToGo })
        this.discounts = order.discounts
        this.toGoPackage = order.package_to_go
        this.changeTgButton(order.unpaid_sum)
        this.$store.commit('setSelectedSlot', undefined)
      } finally {
        this.loading = false
      }
    },
    clearBasket() {
      this.$store.commit('setBasket', {})
      window.WebApp.disableClosingConfirmation()
      this.$store.commit('mb_hide')
      // window.Telegram.WebApp.isClosingConfirmationEnabled = false
      // window.Telegram.WebApp.MainButton.hide()
    },
    changeTgButton(unpaidSum) {
      this.$store.commit('mb_setClick', this.payFunc)
      this.$store.commit('mb_setText', `Оплатить ${unpaidSum} ₽`)
      this.$store.commit('mb_show')
      // window.Telegram.WebApp.MainButton.onClick(this.payFunc)
      // window.Telegram.WebApp.MainButton.text = `Оплатить ${unpaidSum} ₽`
      // window.Telegram.WebApp.MainButton.show()
    }
  },

  components: { BasketItem, DiscountItem, Loading }
}
</script>

<style>
/* Checked */
.form_radio_btn input[type=radio]:checked + label {
	@apply bg-accent
}

/* Disabled */
.form_radio_btn input[type=radio]:disabled + label {
	@apply bg-disabled text-inactive
}
</style>
